<ng-template #templateSelectedResources let-item="item" xmlns="http://www.w3.org/1999/html">
  @if (item.mode == 'focus') {
    <span class="label label-warning" style="height: 0.75rem; vertical-align: baseline;">focus</span>
  } @else if (item.mode == 'ignore') {
    <span class="label label-danger" style="height: 0.75rem; vertical-align: baseline;">ignore</span>
  } @else {
    <span class="label label-danger" style="height: 0.75rem; vertical-align: baseline;">{{item.mode}}</span>
  }
  <span>{{ item.resource.name }}</span>
</ng-template>

<ng-template #templateDisplayResources let-item='item'>
  @if (item.mode == 'focus') {
    <span class="label label-warning" style="height: 0.75rem; vertical-align: baseline;">focus</span>
  } @else if (item.mode == 'ignore') {
    <span class="label label-danger" style="height: 0.75rem; vertical-align: baseline;">ignore</span>
  } @else {
    <span class="label label-danger" style="height: 0.75rem; vertical-align: baseline;">{{item.mode}}</span>
  }
  <span
    *ngIf="item.resource.name === undefined && item.resource.ipaddress !== undefined">{{ item.resource.ipaddress }}</span>
  <span *ngIf="item.resource.name !== undefined">{{ item.resource.name }}</span>
</ng-template>

<ng-template #templateDisplayResourcesWhenEmpty>
</ng-template>

<ng-template #templateDisplayResourcesWhenErrors>
</ng-template>

<clr-modal [(clrModalOpen)]="customDateSelectionModalOpen">
  <h3 class="modal-title">Select a time interval</h3>
  <div class="modal-body">
    <form clrForm>
      <clr-date-container>
        <label>From</label>
        <input type="date" autocomplete="off" clrDate name="fromDate" [(clrDate)]="fromDate" />
      </clr-date-container>
      <clr-date-container>
        <label>To</label>
        <input type="date" autocomplete="off" clrDate name="toDate" [(clrDate)]="toDate" />
      </clr-date-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="customDateSelectionModalOpen = false;">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="setCustomTimeSelection(fromDate, toDate);customDateSelectionModalOpen = false;">Ok</button>
  </div>
</clr-modal>

<!-- Dialog of the automatic theme switch, opened from the Theme submenu of the settings dropdown -->
<app-theme-schedule [(open)]="themeScheduleModalOpen"></app-theme-schedule>

<div class="main-container" [ngClass]="isLightTheme ? 'highcharts-light': 'highcharts-dark'">
  <clr-modal [(clrModalOpen)]="openHeatmapModal" [clrModalStaticBackdrop]="false" [clrModalSize]="'xl'">
    <h3 class="modal-title">{{ "dcnetscope.heatmap.select_time_text" | transloco }}</h3>
    <div class="modal-body">
      <div class="clr-row">
        <div class="clr-col-12">
        </div>
      </div>
    </div>
  </clr-modal>

  @if (newReleaseInfo != undefined) {
    <clr-alert [clrAlertType]="'info'" [clrAlertAppLevel]="true">
      <clr-alert-item>
        <span class="alert-text">
          We detected a new update (version {{newReleaseInfo.version}}), you can download it from our website.
          <clr-signpost>
            <span clrSignpostTrigger>
              <u style="cursor: pointer; text-underline: white;">
                Learn more about the update.
              </u>
            </span>
            <clr-signpost-content [clrPosition]="'bottom-middle'" style="" *clrIfOpen>
              <markdown
                [data]="newReleaseInfo.message"
                [inline]="false">
              </markdown>
            </clr-signpost-content>
          </clr-signpost>
        </span>
        <div class="alert-actions">
          <a href="https://www.easyvirt.com/en/updates-dc-netscope/"><button class="btn alert-action" (click)="reloadBrowser()">Click to download the update</button></a>
        </div>
      </clr-alert-item>
    </clr-alert>
  }

  @if (isError) {
    <clr-alert [clrAlertType]="'danger'" [clrAlertAppLevel]="true">
      <clr-alert-item>
        <span class="alert-text">We couldn’t load the data. This usually happens when your session has expired. Please refresh or log in again.</span>
        <div class="alert-actions">
          <button class="btn alert-action" (click)="reloadBrowser()">Click to reload page</button>
        </div>
      </clr-alert-item>
    </clr-alert>
  }

  <div class="clr-row" style="margin: 0px; background-color: rgb(0, 55, 76); color : white; overflow: visible;">
    <div class="clr-col" id="logo" style="flex-grow: 0; color: white; text-align: center; background-color: #08293f;">
      <table style="height: 100%; min-width: 170px; font-weight: 400; font-size: .9rem; letter-spacing: .01em; text-decoration: none; color: white;">
        <tr>
          <td>
            <img src="/assets/img/logo-dark.svg" style="height: 40px; padding: 5px;">
          </td>
          <td style="text-align: left;"><span style="color: #00ECB5">DC</span> Netscope</td>
        </tr>
      </table>
    </div>
    <div class="clr-col" id="flow_view_title" style="flex-grow: 0; color: white; text-align: center;">
      <table style="height: 100%; min-width: 100px; font-weight: 400; font-size: .8rem; letter-spacing: .01em; text-decoration: none; color: white;">
        <tr>
          <td>
            <cds-icon [attr.shape]="iconShape" style="margin-right: 10px; margin-bottom: 3px;" size="md"></cds-icon>
          </td>
          <td style="text-align: left;">{{ "dcnetscope." + viewLabel | transloco }}</td>
        </tr>
      </table>
    </div>

    <div class="clr-col" id="flow_view_datepicker_button"
         style="flex-grow: 0; cursor: pointer; background-color: rgb(38, 85, 103);">
      <clr-dropdown [clrCloseMenuOnItemClick]="true" style="height: 100%;">
      <button id="change-time-button" clrDropdownTrigger aria-label="Dropdown demo button" style="height: 100%;">
        <a style="pointer-events: none">
          <div class="clr-row" style="height: 100%; padding: 5px; pointer-events: none;">
            <table style="height: 100%; color: rgb(250, 250, 250); text-align: center; font-family: 'Metropolis', 'Avenir Next', 'Helvetica Neue', 'Arial, sans-serif';
                      font-size: 18px; font-weight: 500;">
              <tr>
                <td>
                  <cds-icon shape="calendar" class="is-solid" style="margin: auto;">
                  </cds-icon>
                </td>
                <td style="padding: 5px; text-align: left;">
                  @if(requestedTimeSelection == 'last 1day') {
                    <span style="position: relative; bottom: 5px; top: 0px;">Last 24 hours</span>
                  } @else if (requestedTimeSelection == 'last 1week') {
                    <span style="position: relative; bottom: 5px; top: 0px;">Last 7 days</span>
                  } @else if (requestedTimeSelection == 'last 1month') {
                    <span style="position: relative; bottom: 5px; top: 0px;">Last 30 days</span>
                  } @else if (requestedTimeSelection == 'last 3months') {
                    <span style="position: relative; bottom: 5px; top: 0px;">Last 3 months</span>
                  } @else if (requestedTimeSelection == 'last 6months') {
                    <span style="position: relative; bottom: 5px; top: 0px;">Last 6 months</span>
                  }   @else if (requestedTimeSelection == 'last 1year') {
                    <span style="position: relative; bottom: 5px; top: 0px;">Last year</span>
                  } @else {
                    <span style="position: relative; bottom: 5px; top: 0px;">{{ timeSelectionLabel }}</span>
<!--                    @if (startTime === endTime) {-->
<!--                      @if (timeResolution == 'daily') {-->
<!--                        <span style="position: relative; bottom: 5px; top: 0px;">{{ startTime * 1000 | date: 'dd/MM/yyyy' }}</span>-->
<!--                      } @else {-->
<!--                        <span style="position: relative; bottom: 5px; top: 0px;">{{ startTime * 1000 | date: 'dd/MM/yyyy HH:mm' }}</span>-->
<!--                      }-->
<!--                    } @else {-->
<!--                      @if (timeResolution == 'daily') {-->
<!--                        <span style="position: relative; bottom: 5px; top: 0px;">{{ startTime * 1000 | date: 'dd/MM/yyyy' }} to {{ endTime * 1000 | date: 'dd/MM/yyyy' }} ({{startTime}}, {{endTime}})</span>-->
<!--                      } @else {-->
<!--                        <span style="position: relative; bottom: 5px; top: 0px;">{{ startTime * 1000 | date: 'dd/MM/yyyy HH:mm' }} to {{ endTime * 1000 | date: 'dd/MM/yyyy HH:mm' }}</span>-->
<!--                      }-->
<!--                    }-->
                  }
                </td>
              </tr>
            </table>
          </div>
        </a>
      </button>
      <clr-dropdown-menu *clrIfOpen>
        <label class="dropdown-header" aria-hidden="true">rolling period</label>
        <div id="change-time-button-1d" aria-label="Dropdown header Action 1" clrDropdownItem (click)="setTimeSelection('last 1day')">Last rolling day</div>
        <div id="change-time-button-1w" aria-label="Dropdown header Action 2" clrDropdownItem (click)="setTimeSelection('last 1week')">Last rolling Week</div>
        <div id="change-time-button-1m" aria-label="Dropdown header Action 2" clrDropdownItem (click)="setTimeSelection('last 1month')">Last rolling Month</div>
        <div id="change-time-button-3m" aria-label="Dropdown header Action 2" clrDropdownItem (click)="setTimeSelection('last 3months')">Last 3 rolling Months</div>
        <div id="change-time-button-6m" aria-label="Dropdown header Action 2" clrDropdownItem (click)="setTimeSelection('last 6months')">Last 6 rolling Months</div>
        <div id="change-time-button-1y" aria-label="Dropdown header Action 2" clrDropdownItem (click)="setTimeSelection('last 1year')">Last rolling Year</div>
        <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
        <div id="change-time-button-custom" aria-label="Dropdown header Action 2" clrDropdownItem (click)="customDateSelectionModalOpen = true">Custom</div>
      </clr-dropdown-menu>
    </clr-dropdown>

    </div>

    <div id="column-flow-combobox" class="clr-col" style="padding-top: 10px; padding-bottom: 5px;">
      <selection-combobox
        #combobox
        [(selectedItems)]="currentComboboxSelection"
        [itemsGenerator]="fetchResourcesForCombobox"
        (onChange)="onComboboxChange($event)"
        [templateSelectedItems]="templateSelectedResources"
        [templateDisplayItems]="templateDisplayResources"
        [templateDisplayWhenEmpty]="templateDisplayResourcesWhenEmpty"
        [templateDisplayWhenErrors]="templateDisplayResourcesWhenErrors"
        [itemsField]="'key'"
        style="white-space: normal;"
      ></selection-combobox>
    </div>

    <div class="clr-col" style="width: 100px; flex-grow: 0; padding-left: 0px;">
      <table style="height: 100%;">
        <tr>
          <td style="padding: 5px;">
            <a href="javascript://" id="flow_view_reload_button" class="nav-link nav-icon" aria-label="reload">
              <cds-icon shape="refresh" (click)="resetData()" *ngIf="!isLoading" style="color: white;"></cds-icon>
              <span id="spinner-main-component" class="spinner spinner spinner-inline spinner-inverse" *ngIf="isLoading">Loading...</span>
            </a>
          </td>
          <td style="padding: 5px;">
            <clr-dropdown [clrCloseMenuOnItemClick]="true">
              <a clrDropdownTrigger href="javascript://" class="nav-link nav-icon" aria-label="settings">
                <cds-icon shape="cog" style="color: white;"></cds-icon>
              </a>
              <clr-dropdown-menu clrPosition="bottom-right" *clrIfOpen>
                <label class="dropdown-header" aria-hidden="true">Connected as {{accountLabel}}</label>
                <div aria-label="Dropdown header Action 2" clrDropdownItem><a style="text-decoration: none; color: inherit; width: 100%;" (click)="logout()">Sign out</a></div>
                <label class="dropdown-header" aria-hidden="true">Settings</label>
                <div aria-label="Dropdown header Action 2" clrDropdownItem><a style="text-decoration: none; color: inherit; width: 100%;" (click)="goToAdmin()" href="/api/">Administration</a></div>
                <!-- Theme submenu: opens to the left, as the settings button sits at the right edge of the bar.
                     The choice is applied and kept in the browser by ThemeService. -->
                <clr-dropdown [clrCloseMenuOnItemClick]="true">
                  <button type="button" clrDropdownTrigger class="theme-trigger"
                          [attr.aria-label]="'Theme, currently ' + themeModeLabel">
                    <span>Theme</span>
                    <span class="theme-current">{{ themeModeLabel }}</span>
                  </button>
                  <clr-dropdown-menu clrPosition="left-top" *clrIfOpen>
                    <button type="button" clrDropdownItem class="theme-choice" (click)="setThemeMode('system')"
                            [attr.aria-label]="'System default, follows your browser, currently ' + systemThemeLabel + (themeMode === 'system' ? ' (selected)' : '')">
                      <cds-icon shape="check" class="theme-check" [class.theme-check-hidden]="themeMode !== 'system'"></cds-icon>
                      <cds-icon shape="computer"></cds-icon>
                      <span class="theme-choice-text">
                        <span>System default</span>
                        <span class="theme-choice-detail">Follows your browser, currently {{ systemThemeLabel }}</span>
                      </span>
                    </button>
                    <button type="button" clrDropdownItem class="theme-choice" (click)="setThemeMode('light')"
                            [attr.aria-label]="'Light theme' + (themeMode === 'light' ? ' (selected)' : '')">
                      <cds-icon shape="check" class="theme-check" [class.theme-check-hidden]="themeMode !== 'light'"></cds-icon>
                      <cds-icon shape="sun"></cds-icon>
                      <span>Light theme</span>
                    </button>
                    <button type="button" clrDropdownItem class="theme-choice" (click)="setThemeMode('dark')"
                            [attr.aria-label]="'Dark theme' + (themeMode === 'dark' ? ' (selected)' : '')">
                      <cds-icon shape="check" class="theme-check" [class.theme-check-hidden]="themeMode !== 'dark'"></cds-icon>
                      <cds-icon shape="moon"></cds-icon>
                      <span>Dark theme</span>
                    </button>
                    <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
                    <button type="button" clrDropdownItem class="theme-choice" (click)="openThemeSchedule()"
                            [attr.aria-label]="'Automatic switch, ' + themeScheduleLabel + (themeMode === 'schedule' ? ' (selected)' : '') + ', opens a dialog'">
                      <cds-icon shape="check" class="theme-check" [class.theme-check-hidden]="themeMode !== 'schedule'"></cds-icon>
                      <cds-icon shape="clock"></cds-icon>
                      <span class="theme-choice-text">
                        <span>Automatic switch...</span>
                        <span class="theme-choice-detail">{{ themeScheduleLabel }}</span>
                      </span>
                    </button>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <label class="dropdown-header" aria-hidden="true">Language</label>
<!--                <div aria-label="Dropdown header Action 1" clrDropdownItem (click)="setLanguage('french')">French</div>-->
                <div aria-label="Dropdown header Action 2" clrDropdownItem (click)="setLanguage('english')">English
                </div>
                <label class="dropdown-header" aria-hidden="true">Misc</label>
<!--                <div clrDropdownItem><a href="https://documentation.dcnetscope.easyvirt.com" style="text-decoration: none;">Documentation</a></div>-->
                <div clrDropdownItem><a href="/documentation/" target="_blank" style="text-decoration: none;">Documentation</a></div>
              </clr-dropdown-menu>
            </clr-dropdown>
          </td>
        </tr>
      </table>
    </div>
  </div>


    <div style="display: flex; flex-direction: column; flex: 1 1 auto; min-width: 0; overflow: hidden;">
      <nav class="subnav" style="flex: 0 0 auto;">
        <ul class="nav">
          <li class="nav-item">
            <!-- Home stands for every NetScope page, not only the dashboard it leads to: it is active whenever the
                 Fortinet tab is not -->
            <a class="nav-link subnav-link-icon" routerLink="/dashboard" [class.active]="!fortinetTab.isActive"
               aria-label="Home">
       <!--        <cds-icon shape="dashboard" size="16"></cds-icon> -->
              <span>Home</span>
          </a>
        </li>
          <!-- Grayed out while no FortiGate has data (see FortinetDevicesService). The title sits on the
               line because the grayed-out link does not react to the mouse. -->
          <li class="nav-item" [class.tab-disabled-item]="!fortinetAvailable"
              [title]="fortinetAvailable ? '' : 'No Fortinet device yet: declare a FortiGate in the Administration'">
            <a class="nav-link subnav-link-icon" routerLink="/fortinet" routerLinkActive="active"
               #fortinetTab="routerLinkActive" aria-label="Fortinet"
               [class.tab-disabled]="!fortinetAvailable"
               [attr.aria-disabled]="fortinetAvailable ? null : true"
               [attr.tabindex]="fortinetAvailable ? null : -1">
  <!--             <cds-icon shape="firewall" size="16"></cds-icon> -->
              <span>Fortinet</span>
          </a>
        </li>
        </ul>
      </nav>


  <div class="content-container">

    <!-- Fortinet pages: their own menu (device scope, sections), see fortinet/fortinet-nav.component -->
    <app-fortinet-nav *ngIf="fortinetMenuShown"></app-fortinet-nav>

    <!-- Flow pages: the application's own menu -->
    <clr-vertical-nav *ngIf="!fortinetMenuShown" [clrVerticalNavCollapsible]="true"
                      [clrVerticalNavCollapsed]="false" class="nav-trigger--bottom">
      <a clrVerticalNavLink routerLink="/dashboard" routerLinkActive="active" style="margin-top:15px;">
        <cds-icon shape="dashboard" clrVerticalNavIcon></cds-icon>
        Dashboard
      </a>
      <a clrVerticalNavLink routerLink="/flows/clusters-viewer" routerLinkActive="active">
        <cds-icon shape="organization" clrVerticalNavIcon></cds-icon>
        Clusters viewer
      </a>
      <a clrVerticalNavLink routerLink="/flows/protocol-analysis" routerLinkActive="active">
        <cds-icon shape="chat-bubble" clrVerticalNavIcon></cds-icon>
        Protocol analysis
      </a>
      <a clrVerticalNavLink routerLink="/apps-groups" routerLinkActive="active">
        <cds-icon shape="node-group" clrVerticalNavIcon></cds-icon>
        Apps groups
      </a>
      <a clrVerticalNavLink routerLink="/flows/networks-viewer" routerLinkActive="active">
        <cds-icon shape="network-switch" clrVerticalNavIcon></cds-icon>
        Networks viewer
      </a>
      <a clrVerticalNavLink routerLink="/flows/dependencies-viewer" routerLinkActive="active">
        <cds-icon shape="recycle" clrVerticalNavIcon></cds-icon>
        Dependencies viewer
      </a>
      <a clrVerticalNavLink routerLink="/heatmap-viewer" routerLinkActive="active">
        <cds-icon shape="heat-map" clrVerticalNavIcon></cds-icon>
        Heatmap viewer
      </a>
      <a clrVerticalNavLink routerLink="/custom-protocols" routerLinkActive="active">
        <cds-icon shape="tags" clrVerticalNavIcon></cds-icon>
        Custom protocols
      </a>
      <a clrVerticalNavLink routerLink="/external_ips" routerLinkActive="active">
        <cds-icon shape="note" clrVerticalNavIcon></cds-icon>
        External IPs
      </a>
<!--      <a clrVerticalNavLink routerLink="/supervision" routerLinkActive="active">-->
<!--        <cds-icon shape="radar" clrVerticalNavIcon></cds-icon>-->
<!--        Supervision-->
<!--      </a>-->
      <a clrVerticalNavLink routerLink="/reports" routerLinkActive="active">
        <cds-icon shape="radar" clrVerticalNavIcon></cds-icon>
        Reports
      </a>
      <a clrVerticalNavLink routerLink="/outside" routerLinkActive="active">
        <cds-icon shape="world" clrVerticalNavIcon></cds-icon>
        Outside Flows
      </a>
<!--      <a clrVerticalNavLink routerLink="/threat_center" routerLinkActive="active">-->
<!--        <cds-icon shape="bug" clrVerticalNavIcon></cds-icon>-->
<!--        Threats center-->
<!--      </a>-->
      <a clrVerticalNavLink routerLink="/topology" routerLinkActive="active">
        <cds-icon shape="tree-view" clrVerticalNavIcon></cds-icon>
        Topology
      </a>
      <a clrVerticalNavLink routerLink="/diagnostic" routerLinkActive="active">
        <cds-icon shape="checkbox-list" clrVerticalNavIcon></cds-icon>
        Diagnostic
      </a>
<!--       <a clrVerticalNavLink routerLink="/fortinet" routerLinkActive="active">
        <cds-icon shape="firewall" clrVerticalNavIcon></cds-icon>
        Fortinet
      </a> -->
<!--      @if (true) {-->
        <a clrVerticalNavLink routerLink="/nis2" routerLinkActive="active">
          <cds-icon shape="clipboard" clrVerticalNavIcon></cds-icon>
  <!--        NIS2-->
          Flows descriptions
        </a>
<!--      }-->
    </clr-vertical-nav>



    <div class="content-area" style="position: relative;">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
